import React, { useState } from "react";
import axios from "./axios";
import { IoAlertCircleOutline, IoCheckmarkCircleOutline } from "react-icons/io5";

const ForgotPassword = () => {
  const [email, setEmail] = useState("");
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);

  const apiUrl = process.env.REACT_APP_API_BASE_URL;

  const validate = () => {
    setError("");
    setSuccess("");
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email.trim())) {
      setError("Ingrese un correo electrónico válido");
      return false;
    }
    return true;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validate()) return;
    setIsSubmitting(true);
    try {
      await axios.post(`${apiUrl}/users/password/forgot`, JSON.stringify({ email }), {
        headers: { "Content-Type": "application/json" },
      });
      setSuccess("Si el correo existe, enviamos instrucciones para recuperar tu contraseña.");
    } catch (err) {
      const msg = err?.response?.data?.error || "Error de conexión";
      setError(msg);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <form className="form" onSubmit={handleSubmit}>
      <label>
        Email:
        <input
          type="email"
          name="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
        />
      </label>
      {error && (
        <p className="error-message">
          <IoAlertCircleOutline /> {error}
        </p>
      )}
      {success && (
        <p className="success-message">
          <IoCheckmarkCircleOutline /> {success}
        </p>
      )}
      <button className="button button-info" type="submit" disabled={isSubmitting}>
        {isSubmitting ? "Enviando…" : "Enviar instrucciones"}
      </button>
    </form>
  );
};

export default ForgotPassword;
